import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ContactDirectory\UpdateInternalContactController::__invoke
* @see app/Http/Controllers/ContactDirectory/UpdateInternalContactController.php
* @route '/api/contact-directory/internal/{internalContact}'
*/
const UpdateInternalContactController = (args: { internalContact: string | { id: string } } | [internalContact: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: UpdateInternalContactController.url(args, options),
    method: 'patch',
})

UpdateInternalContactController.definition = {
    methods: ["patch"],
    url: '/api/contact-directory/internal/{internalContact}',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\ContactDirectory\UpdateInternalContactController::__invoke
* @see app/Http/Controllers/ContactDirectory/UpdateInternalContactController.php
* @route '/api/contact-directory/internal/{internalContact}'
*/
UpdateInternalContactController.url = (args: { internalContact: string | { id: string } } | [internalContact: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { internalContact: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { internalContact: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            internalContact: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        internalContact: typeof args.internalContact === 'object'
        ? args.internalContact.id
        : args.internalContact,
    }

    return UpdateInternalContactController.definition.url
            .replace('{internalContact}', parsedArgs.internalContact.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ContactDirectory\UpdateInternalContactController::__invoke
* @see app/Http/Controllers/ContactDirectory/UpdateInternalContactController.php
* @route '/api/contact-directory/internal/{internalContact}'
*/
UpdateInternalContactController.patch = (args: { internalContact: string | { id: string } } | [internalContact: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: UpdateInternalContactController.url(args, options),
    method: 'patch',
})

export default UpdateInternalContactController